import React from 'react';
import { connect } from 'react-redux';
import { State } from '../data/rootReducer';
import { login, LoginStatus } from '../data/sessionSlice';
import { AppConnectedProps } from '../data/store';

import './LoginForm.scss';

const connector = connect((state: State) => ({ session: state.session }));

interface LoginState {
  username: string;
  password: string;
}

class LoginForm extends React.Component<AppConnectedProps<typeof connector>> {
  state: LoginState = {
    username: '',
    password: '',
  };

  render() {
    return (
      <div className="login">
        {this.props.session.loginStatus === LoginStatus.LOGGED_IN ? (
          <div className="status info">Benvenuto</div>
        ) : this.props.session.loginStatus === LoginStatus.LOGIN_ERROR ? (
          <div className="status error">{this.props.session.loginError}</div>
        ) : (
          <div className="status"></div>
        )}
        <form className="form" onSubmit={(e) => e.preventDefault()}>
          <label>
            <span className="label">Username</span>
            <input
              type="text"
              name="username"
              onChange={(e) => this.setState({ username: e.target.value })}
              value={this.state.username}
            />
          </label>
          <label>
            <span className="label">Password</span>
            <input
              type="password"
              name="password"
              onChange={(e) => this.setState({ password: e.target.value })}
              value={this.state.password}
            />
          </label>
          <button
            onClick={(e) => {
              this.props.dispatch(login(this.state.username, this.state.password));
              e.preventDefault();
            }}
            disabled={this.props.session.loginStatus === LoginStatus.LOGGING_IN}
          >
            Login
          </button>
        </form>
      </div>
    );
  }
}

export default connector(LoginForm);
